var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3268 3C16.3526 3 15.4183 3.387 14.7295 4.07585L4.24896 14.5564C4.08955 14.7158 4 14.932 4 15.1574V19.15C4 19.6194 4.38056 20 4.85 20H8.84258C9.06802 20 9.28422 19.9104 9.44362 19.751L19.9242 9.27051C20.613 8.58166 21 7.64737 21 6.67318C21 5.69899 20.613 4.76471 19.9242 4.07585C19.2353 3.387 18.301 3 17.3268 3ZM15.9316 5.27793C16.3016 4.90789 16.8035 4.7 17.3268 4.7C17.8501 4.7 18.352 4.90789 18.7221 5.27793C19.0921 5.64797 19.3 6.14986 19.3 6.67318C19.3 7.1965 19.0921 7.69839 18.7221 8.06843L18.3093 8.48124C18.2783 8.4345 18.2422 8.39014 18.201 8.34896L15.651 5.79896C15.6099 5.75778 15.5655 5.7217 15.5188 5.69074L15.9316 5.27793ZM14.3407 6.86876L5.7 15.5095V18.3H8.4905L17.1312 9.65926C17.0845 9.6283 17.0401 9.59222 16.999 9.55104L14.449 7.00104C14.4078 6.95986 14.3717 6.9155 14.3407 6.86876Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a4cc1632113067e2065947c953dbd7b8.svg";
export { ForwardRef as ReactComponent };